import { createJSONStorage } from "zustand/middleware";
import { createStore } from ".";
import type { MyInfo } from "../../types/auth.types";

const initState = {
  userId: 0,
  name: "",
  nickName: "",
  birthdate: "",
  mobileno: "",
  mobileco: "",
  email: "",
  sidoCode: "",
  sidoName: "",
  sigunguCode: "",
  sigunguName: "",
  isMarketingAgreed: false,
  isMarketingPopupOpen: false,
  qrTournamentList: [],
  gender: "",
  nat: "domestic" as "domestic" | "foreign",
};

interface MyInfoState {
  myInfo: MyInfo;
  setMyInfo: (myInfo: Partial<MyInfo>) => void;
  clearMyInfo: () => void;
}

export const useMyInfoStore = createStore<MyInfoState>(
  (set) => ({
    myInfo: initState,
    setMyInfo: (partial) =>
      set((state) => ({ myInfo: { ...state.myInfo, ...partial } })),
    clearMyInfo: () => set(() => ({ myInfo: initState })),
  }),
  {
    name: "parkgolf-myInfo",
    storage: createJSONStorage(() => sessionStorage),
  },
);
